import { Action } from '@ngrx/store';
import { QueryParamsModel } from '../../_base/crud';
import { AffiliationType } from '../_models/affiliation-type.model';

export enum AffiliationTypeActionTypes {
  AllAffiliationTypesRequested = '[AffiliationTypes Module] All AffiliationTypes Requested',
  AllAffiliationTypesLoaded = '[AffiliationTypes API] All AffiliationTypes Loaded',
  AffiliationTypeOnServerCreated = '[Edit AffiliationType Component] AffiliationType On Server Created',
  AffiliationTypeCreated = '[Edit AffiliationType Dialog] AffiliationType Created',
  AffiliationTypeOnServerUpdated = '[Edit AffiliationType Dialog] AffiliationType On Server Updated',
  AffiliationTypeUpdated = '[Edit AffiliationType Dialog] AffiliationType Updated',
  AffiliationTypeOnServerDeleted = '[AffiliationTypes List Page] AffiliationType On Server Deleted',
  AffiliationTypeDeleted = '[AffiliationTypes List Page] AffiliationType Deleted',
  AffiliationTypesPageRequested = '[AffiliationTypes List Page] AffiliationTypes Page Requested',
  AffiliationTypesPageLoaded = '[AffiliationTypes API] AffiliationTypes Page Loaded',
  AffiliationTypesPageCancelled = '[AffiliationTypes API] AffiliationTypes Page Cancelled',
  AffiliationTypesPageToggleLoading = '[AffiliationTypes] AffiliationTypes Page Toggle Loading',
  AffiliationTypesActionToggleLoading = '[AffiliationTypes] AffiliationTypes Action Toggle Loading',
  ThrowAffiliationTypeError = '[AffiliationTypes] ThrowAffiliationTypeError',
  ClearAffiliationTypeErrors = '[AffiliationTypes] ClearAffiliationTypeErrors',
}

export class AffiliationTypeOnServerCreated implements Action {
  readonly type = AffiliationTypeActionTypes.AffiliationTypeOnServerCreated;

  constructor(public payload: { affiliationType: AffiliationType }) {}
}

export class AffiliationTypeCreated implements Action {
  readonly type = AffiliationTypeActionTypes.AffiliationTypeCreated;

  constructor(public payload: { affiliationType: AffiliationType }) {}
}

export class ThrowAffiliationTypeError implements Action {
  readonly type = AffiliationTypeActionTypes.ThrowAffiliationTypeError;

  constructor(public payload: { error: any }) {}
}

export class ClearAffiliationTypeErrors implements Action {
  readonly type = AffiliationTypeActionTypes.ClearAffiliationTypeErrors;
}

export class AffiliationTypeOnServerUpdated implements Action {
  readonly type = AffiliationTypeActionTypes.AffiliationTypeOnServerUpdated;

  constructor(
    public payload: {
      affiliationType: AffiliationType;
    },
  ) {}
}

export class AffiliationTypeUpdated implements Action {
  readonly type = AffiliationTypeActionTypes.AffiliationTypeUpdated;

  constructor(
    public payload: {
      affiliationType: AffiliationType;
    },
  ) {}
}

export class AffiliationTypeOnServerDeleted implements Action {
  readonly type = AffiliationTypeActionTypes.AffiliationTypeOnServerDeleted;

  constructor(public payload: { id: number }) {}
}

export class AffiliationTypeDeleted implements Action {
  readonly type = AffiliationTypeActionTypes.AffiliationTypeDeleted;

  constructor(public payload: { id: number }) {}
}

export class AffiliationTypesPageRequested implements Action {
  readonly type = AffiliationTypeActionTypes.AffiliationTypesPageRequested;

  constructor(public payload: { page: QueryParamsModel }) {}
}

export class AffiliationTypesPageLoaded implements Action {
  readonly type = AffiliationTypeActionTypes.AffiliationTypesPageLoaded;

  constructor(
    public payload: {
      affiliationTypes: AffiliationType[];
      totalCount: number;
      page: QueryParamsModel;
    },
  ) {}
}

export class AffiliationTypesPageCancelled implements Action {
  readonly type = AffiliationTypeActionTypes.AffiliationTypesPageCancelled;
}

export class AffiliationTypesPageToggleLoading implements Action {
  readonly type = AffiliationTypeActionTypes.AffiliationTypesPageToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export class AffiliationTypesActionToggleLoading implements Action {
  readonly type = AffiliationTypeActionTypes.AffiliationTypesActionToggleLoading;

  constructor(public payload: { isLoading: boolean }) {}
}

export type AffiliationTypeActions =
  | AffiliationTypeCreated
  | AffiliationTypeUpdated
  | AffiliationTypeDeleted
  | AffiliationTypeOnServerCreated
  | AffiliationTypeOnServerUpdated
  | AffiliationTypeOnServerDeleted
  | AffiliationTypesPageLoaded
  | AffiliationTypesPageCancelled
  | AffiliationTypesPageToggleLoading
  | AffiliationTypesPageRequested
  | ThrowAffiliationTypeError
  | ClearAffiliationTypeErrors
  | AffiliationTypesActionToggleLoading;
